export default __webpack_public_path__ + "static/media/interaction.a7e54d92.svg";